import React from 'react';

interface IconWifiProps {
    className?: string;
}

const IconWifi: React.FC<IconWifiProps> = ({ className }) => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g opacity="0.5">
                <path
                    d="M20.5576 13.4952C18.7069 11.5337 16.2003 10.4541 13.4995 10.4541C10.7987 10.4541 8.29211 11.5337 6.44141 13.4952L8.20126 15.3592C9.58276 13.8959 11.4633 13.0892 13.4995 13.0892C15.5356 13.0905 17.4162 13.8959 18.7977 15.3592L20.5576 13.4952Z"
                    fill="currentColor"
                />
                <path
                    d="M24 9.52112C18.3097 3.49296 8.69027 3.49296 3 9.52112L4.75985 11.3851C9.49801 6.36665 17.502 6.36665 22.2401 11.3851L24 9.52112Z"
                    fill="currentColor"
                />
                <path
                    d="M13.4994 21.0004C14.8742 21.0004 15.9886 19.82 15.9886 18.364C15.9886 16.9079 14.8742 15.7275 13.4994 15.7275C12.1247 15.7275 11.0103 16.9079 11.0103 18.364C11.0103 19.82 12.1247 21.0004 13.4994 21.0004Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
};

export default IconWifi;